import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=f5ae5088"
import script from "./AddButton.vue?vue&type=script&lang=ts"
export * from "./AddButton.vue?vue&type=script&lang=ts"
import style0 from "./AddButton.vue?vue&type=style&index=0&id=f5ae5088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports